<script setup lang="ts">
interface WrapProps {
  type?: string
}

withDefaults(defineProps<WrapProps>(), {
  type: '',
})

const $attrs = useAttrs()

const wrap = ref<HTMLElement | null>(null)

const filteredAttrs = computed(() => {
  const myAttrs = { ...$attrs }
  delete myAttrs.class

  return myAttrs
})

defineExpose({ wrap })
</script>

<template>
  <div ref="wrap" class="m-wrap" v-bind="filteredAttrs">
    <slot />
  </div>
</template>

<style lang="scss">
.m-wrap {
  &:hover {
    
  }

  .m-el {

  }
}
</style>
